var api = require("!../../../../../../home/silvano/repos/brprev/censo-web/censoweb/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../home/silvano/repos/brprev/censo-web/censoweb/node_modules/css-loader/dist/cjs.js??ref--13-1!../../../../../../home/silvano/repos/brprev/censo-web/censoweb/node_modules/postcss-loader/src/index.js??embedded!../../../../../../home/silvano/repos/brprev/censo-web/censoweb/node_modules/sass-loader/dist/cjs.js??ref--13-3!./core.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;